export const FIRST_FRAME = "#t=0.001"

// With preload="metadata" and no poster, browsers paint nothing until play;
// a start-time fragment makes Chrome and Safari draw the first frame.
export const withFirstFrame = (src: string) =>
	src.includes("#") ? src : `${src}${FIRST_FRAME}`
